import { FilmTile } from "@components/film/FilmTile"
import { NewsTile } from "@components/news/NewsTile"
import { Button } from "@components/ui/Button"
import { tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Latest News",
  tags: ["subpage", "homepage-root"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("news/latest-news", (props) => {
  const styles = createStyles()
  return (
    <div className={styles.wrapper()}>
      {/* Heading/CTA */}
      <div className="flex justify-between items-center mb-7 md:mb-4">
        <EditableText
          store="title"
          as="h4"
          className="type-title-s uppercase"
          placeholder="Latest News"
          defaultValue="Latest News"
          plainText
        />
        <Button href="/news" variant="link">
          <EditableText store="cta" as="span" placeholder="View all" defaultValue="View all" plainText />
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-7 md:gap-4">
        {/* Film tiles */}
        {props.newss?.nodes?.map((item, i) => (
          <div key={i} className={styles.item()}>
            <NewsTile item={item} hideExcerpt />
          </div>
        ))}
      </div>
    </div>
  )
})

const createStyles = tv({
  slots: {
    wrapper: "p-4 my-10",
    item: "col-span-1",
  },
})
